export { default } from './request-equipment-service-header';
